// #region Cubic Bezier Easing ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const cubicBezier = (x0: number, y0: number, x1: number, y1: number) => {
  if (!(x0 >= 0 && x0 <= 1 && x1 >= 0 && x1 <= 1)) {
    throw new Error(
      `CubicBezier x1 & x2 values must be { 0 < x < 1 }, got { x1 : ${x0}, x2: ${x1} }`,
    )
  }

  const ax = 1.0 - (x1 = 3.0 * (x1 - x0) - (x0 *= 3.0)) - x0
  const ay = 1.0 - (y1 = 3.0 * (y1 - y0) - (y0 *= 3.0))

  let i = 0
  let r = 0.0
  let s = 0.0
  let d = 0.0
  let x = 0.0

  return (t: number) => {
    for (r = t, i = 0; 32 > i; ++i) {
      if (1e-5 > Math.abs((x = r * (r * (r * ax + x1) + x0) - t))) {
        return r * (r * (r * ay + y1) + y0)
      } else if (1e-5 > Math.abs((d = r * (r * ax * 3.0 + x1 * 2.0) + x0))) {
        break
      } else {
        r -= x / d
      }
    }

    if ((s = 0.0) > (r = t)) {
      return 0
    } else if ((d = 1.0) < r) {
      return 1
    }

    while (d > s) {
      if (1e-5 > Math.abs((x = r * (r * (r * ax + x1) + x0)) - t)) {
        break
      } else {
        if (t > x) {
          s = r
        } else {
          d = r
        }

        r = 0.5 * (d - s) + s
      }
    }

    return r * (r * (r * ay + y1) + y0)
  }
}

// #endregion ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
